import { walletHttp } from 'shared/api/wallet-axios';
import { REQUEST, SUCCESS, FAILURE } from 'shared/lib/reducers/action-type.util';
export const ACTION_TYPES = {
    FETCH_ACCOUNT: 'cmsAccount/FETCH_ACCOUNT',
    RESET: 'cmsAccount/RESET',
};
const initialState = {
    loading: false,
    errorMessage: null,
    account: null,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case REQUEST(ACTION_TYPES.FETCH_ACCOUNT):
            return {
                ...state,
                loading: true,
                errorMessage: null,
            };
        case SUCCESS(ACTION_TYPES.FETCH_ACCOUNT):
            return {
                ...state,
                loading: false,
                account: action.payload.data ?? null,
            };
        case FAILURE(ACTION_TYPES.FETCH_ACCOUNT):
            return {
                ...state,
                loading: false,
                errorMessage: action.payload,
            };
        case ACTION_TYPES.RESET:
            return initialState;
        default:
            return state;
    }
};
export const getAccountInfo = () => ({
    type: ACTION_TYPES.FETCH_ACCOUNT,
    payload: walletHttp().get('users/api/account'),
});
export const resetCmsAccount = () => ({
    type: ACTION_TYPES.RESET,
});
